import clsx from 'clsx'
import {FC, Fragment} from 'react'
import {Row} from 'react-table'
import { TableNotesRow } from './TableNotesComponents'


type Props = {
  row: Row<any>
}

const TableCommitteeMemberRow: FC<Props> = ({row}) => {

  const has_notes = row.original?.notes && row.original.notes.length > 0;

  return (
  <Fragment>
    <tr {...row.getRowProps()}>
    {row.cells.map((cell, cidx) => {
    return (
      <td
        {...cell.getCellProps()}
        key={`cell${row.id}${cidx}`}
        rowSpan={(cidx < 2  && has_notes) ? 2 : 1}
        className={clsx('fs-7',                    
          {'align-top min-w-150px' : cidx === 0},
          {'align-top min-w-100px' : cidx === 1},
          {'min-w-200px' : cidx === 2},
          {'w-150px' : cidx === 3}
        )}                
      >
      {cell.render('Cell')}
      </td>
    )
    })}
    </tr>
    { has_notes && 
    <TableNotesRow colSpan={3} notes={row.original.notes} />    
    }
  </Fragment>
  )
}
export {TableCommitteeMemberRow}
